import moment from "moment-timezone";

/**
 * Format the dateTime differently according the time passed
 * @param {*} dateTime
 * @returns
 */
export const formatDateTimelapse = (dateTime) =>
  moment(moment().format()).diff(dateTime, "days") > 1
    ? moment(dateTime).format("MMM D, YYYY")
    : moment(dateTime).fromNow();
